import { Component, HostBinding, Input, Output, EventEmitter, OnInit, ViewEncapsulation } from '@angular/core';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Ng2SmartTableModule, LocalDataSource, ViewCell } from 'ng2-smart-table';
import { Pipe } from '@angular/core';

@Component({
  template: '<a style="color:#1e6bb8;" (click)="onClick()">{{renderValue}}</a>',
})
@Pipe({name: 'dateview2'})
export class DateView2Component extends DatePipe implements ViewCell, OnInit {

     

    renderValue: string;

    @Input() value: string | number;
  @Input() rowData: any;

  @Output() save: EventEmitter<any> = new EventEmitter();

    ngOnInit() {

        this.renderValue = super.transform(this.value.toString(), 'dd-MM-yyyy HH:mm');
    }
  onClick() {
    this.save.emit(this.rowData);
  }
}
